import React, { useMemo } from "react";
import { Routes } from "./RoutesV1";
import { WowSeeAnalyticsProvider } from "wowsee-analytics-react";
import { AnalyticsTracker } from "./components/AnalyticsTracker";
import { getQueryPath, getUserId } from "./utilities/url";

export const App = () => {
  const userId = useMemo(() => getUserId(), []);

  return (
    <WowSeeAnalyticsProvider
      apiURL={process.env.REACT_APP_ANALYTICS_API_URL ?? ""}
      getPath={() => getQueryPath()}
    >
      <AnalyticsTracker />
      {userId ? (
        <div>
          <Routes userId={userId} />
        </div>
      ) : (
        <div>Something went wrong</div>
      )}
    </WowSeeAnalyticsProvider>
  );
};
